import rest from "../script/rest";

class WorstcaseRest {

    async getResult(calculationId, viewType, slice) {
        const url = "/rest/worstcase/getResult"
            + "?calculationId=" + calculationId
            + "&slice=" + slice
            + "&viewType=" + viewType;
        const response = await rest.get(url);
        const result = await response.json();
        return result;
    }

    async getColorBar(calculationId, slice) {
        const url = "/rest/worstcase/getColorBar"
            + "?calculationId=" + calculationId
            + "&slice=" + slice;
        const response = await rest.get(url);
        const json = await response.json();
        return json;
    }

    async getDetailData(calculationId, slice) {
        const url = "/rest/worstcase/getDetailData"
            + "?calculationId=" + calculationId
            + "&slice=" + slice;
        const response = await rest.get(url);
        return response.json();
    }

    async getFieldInterpolatedInSlice(calculationId, u, v, slice) {
        const url = "/rest/worstcase/getFieldInterpolated"
            + "?calculationId=" + calculationId
            + "&slice=" + slice
            + "&u=" + u
            + "&v=" + v;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }
}
const worstcaseRest = new WorstcaseRest();
window.worstcaseRest = worstcaseRest;
export default worstcaseRest;